import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

import { FanDeploymentProfileService, FanProfileModel } from './shared';
import { BreadCrumbService, GridOptionsModel, AccordionModel, PageLoaderService } from './../../../lib/ng2-sapmp/src/ui-components';
import { UtilityService } from './../../../lib/ng2-sapmp/src/providers';
import { FANDATA, MOBILEPIVOTS, ERRCODES, SIGNUPDATA } from 'config';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot';
import { SignupService } from './../signup/shared/providers/signup.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-fan-deployment-profile',
  templateUrl: './fan-deployment-profile.component.html',
  styleUrls: ['./fan-deployment-profile.component.scss'],
  providers: [FanDeploymentProfileService, SignupService],
  encapsulation: ViewEncapsulation.None
})
export class FanDeploymentProfileComponent implements OnInit {

  gridOptions: GridOptionsModel;
  fans: FanProfileModel;
  accordionList: Array<AccordionModel>;
  fanList: Array<any>;
  pageDetails: any;
  selectedProfile: String;
  error: boolean;
  errorMessage: string;
  pivots: Array<MobilePivotModel>;
  settingsConfig: any;
  isMobile: any;
  preSelectedMdmDetail: string;
  selectedMdm: string;
  emmAccountId: string;
  mdmDetails: any;
  oemStatus = false;
  supportArticles: any;
  article: any;
  showOverviewModal: boolean;
  videoId: string;
  prodFlag: boolean;
  supportArticle = false;
  emmProductCode: string;
  fanID: string;
  static SANITIZE;


  constructor(private breadCrumbService: BreadCrumbService, private fanDeploymentService: FanDeploymentProfileService,
    private utilityService: UtilityService, private router: Router, private _sanitizer: DomSanitizer, private pageLoaderService: PageLoaderService,
    private signupService: SignupService) {
    this.pageLoaderService.setPageLoaderStatus(false);
    this.fans = new FanProfileModel();
    this.accordionList = [];
    this.fanList = [];
    this.checkProfile();
    FanDeploymentProfileComponent.SANITIZE = _sanitizer;
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.pivots = this.pivots = MOBILEPIVOTS.SINGLEFANPROFILE;
    this.settingsConfig = SIGNUPDATA.SettingsPage;
    this.fanID = sessionStorage.getItem("fanID");
    this.fanDeploymentService.getFanDeploymentPageContent(this.selectedProfile)
      .subscribe(response => {
        this.fans = response;
        this.fans.notifications = this.fans.notifications.toLowerCase();
        if (this.fans.notifications === 'both') {
          this.fans.notifications = 'email and text';
        }
        this.emmProductCode = this.fans.emmProductCode;
        this.breadCrumbService.setCurrentBreadCrumb({ label: '' + this.fans.profileName + ': ' + this.fanID,
        routerLink: 'manageInventory/fanDeploymentProfile' });
        this.pageDetails = FANDATA.pageDetails;
        this.getFanDetails();
        this.getMDMname();
        this.pageLoaderService.setPageLoaderStatus(true);
      }, (err) => {
        this.handleError(err,'genericErrorMessage');
        this.breadCrumbService.setCurrentBreadCrumb({ label: 'Single Fan Profile', routerLink: 'manageInventory/fanDeploymentProfile' });
      });
      this.fanDeploymentService.createPageLoadProperties();
      this.mdmDetails = JSON.parse(sessionStorage.getItem('mdmDetails'));
      if (this.mdmDetails.productCode === 'ADDPZTE') {
        this.oemStatus = true;
        }
        this.supportArticles = [{ id: 1, isActive: true, category: 'Help', content: '' }];
        const pageName = 'deviceInventoryPage';
        if (!this.oemStatus) {
          this.signupService.requestSupportContent(this.utilityService.getEnvConfig().getSupportDocument + pageName).
          subscribe(resp => {
        this.article = resp.supportArticles;
        this.article.name = this.article.availableArticle[0].name;
        this.supportArticle = true;
      }, (err) => {
      //  this.handleError(err);
      });
      }

  }
  getMDMname() {
    this.mdmDetails = JSON.parse(sessionStorage.getItem('mdmDetails'));
      if (this.emmProductCode === 'ADDPMDM') {
        this.fans.mdmServiceName = this.pageDetails.mdmServiceIbm;
        this.emmAccountId = this.mdmDetails.ibmEmmAccountId;
        this.oemStatus = false;
       } else if (this.emmProductCode === 'DMPGZTP') {
        this.fans.mdmServiceName = this.pageDetails.mdmServiceZtp;
        this.emmAccountId = this.mdmDetails.googleEmmAccountId;
        this.oemStatus = true;
       } else if (this.emmProductCode === 'DMPSKME') {
        this.fans.mdmServiceName = this.pageDetails.mdmServiceKme;
        this.emmAccountId = this.mdmDetails.samsungEmmAccountId;
        this.oemStatus = true;
       } else {
        this.fans.mdmServiceName = '';
       }
      }

  getSupportContent(articleNumber) {
    if (this.article.availableArticle[articleNumber].type === 'url') {
      this.initPopupModal(articleNumber);
    }
  }

  initPopupModal(articleNumber) {
    this.videoId = this.article.availableArticle[articleNumber].url;
    this.showOverviewModal = true;
  }

  closeOverviewModal() {
    this.showOverviewModal = false;
  }

  handleError(error,type) {
    this.error = true;
    this.errorMessage = ERRCODES[type];
    this.pageLoaderService.setPageLoaderStatus(true);
  }

  getFanDetails() {
    this.fanList = this.fans.fanList;
    this.initGrid();
    if (this.fanList && this.fanList.length > 5 && this.accordionList.length === 0) {
      this.accordionList.push({ id: 1, isActive: false, category: 'Foundation Accounts assigned to this profile', description: '' });
    }
  }

  initGrid() {
    const options = new GridOptionsModel();
    options.enableFiltering = false;
    options.enableSorting = false;
    options.multiSelect = false;
    const pagination = {
      recordsPerPage: 20,
      currentPage: 1,
      isServerSide: false,
      totalRecords: this.fanList.length
    };
    options.Paginations = pagination;
    options.callbacks = { callBackAppNameCellTemplate: this.callBackAppNameCellTemplate };
    options.gridData = this.fanList;
    options.columnDefinitions = FANDATA.columnDefinitions;
    this.gridOptions = options;
  }

  callBackAppNameCellTemplate(element, row, field, currentElem, type) {
    if (type === 'template') {
      if (row.fanstatus === 'ACTIVE' &&
      JSON.parse(sessionStorage.getItem('noOfDevice')) >= 1 ) {
        return FanDeploymentProfileComponent.SANITIZE.bypassSecurityTrustHtml(`<a href="javascript:void(0)" tabindex="0" class='fan'>${row.fanId}</a>`);
      } else {
        return `<span>${row.fanId}</span>`;
      }

    } else if (type.target.classList.contains('fan')) {
      currentElem.onDataChange.emit({ data: row, type: 'fanId' });
    }
  }

  onRowClick(action) {
    if (action.type === 'fanId') {
      this.fanDeploymentService.setSelectedFan(action.data.fanId);
      this.router.navigate(['manageInventory/deviceInventory']);
    }
  }

  checkProfile() {
    this.selectedProfile = this.fanDeploymentService.getSelectedProfileID();
    if (this.selectedProfile === undefined) {
      this.back();
    }
  }

  back() {
    this.breadCrumbService.removeLastBreadCrumb();
    const currentUrl = this.breadCrumbService.getLastUrlFromBreadCrumb().routerLink;
    this.router.navigate([currentUrl]);
  }
}
